export default __webpack_public_path__ + "static/media/Geografia.c900936c.png";